import React from 'react';
import { useState } from "react";

export const GlobalIPApp = () =>
{
	const [gip, setGIP] = useState("");

	const url = 'https://checkip.amazonaws.com';
	//const url = 'https://ne1rkwlz0b.execute-api.ap-northeast-1.amazonaws.com/Dev/globalip';

	const getGIP = async () => {
		try {
			const res = await fetch(url);
			setGIP((await res.text()));
		} catch (err) {
			console.error(err);
		}
	};

	return (
		<div className="container">
			<div className="row">
				<div className="col">
					{url}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div type="button" className="btn btn-primary" onClick={()=>getGIP()}>GlobalIP</div>
				</div>
			</div>
			<div className="row">
				<div className="col">
					{gip}
				</div>
			</div>
		</div>
	);
};
